import {z} from '@hono/zod-openapi';

export const assistantAvailabilityResponseSchema = z
  .discriminatedUnion('status', [
    z.object({
      status: z.literal('available').openapi({example: 'available'}),
      /**
       * Whether the issue-reporting capability (bug report / feature request) is enabled on this
       * server. Absent on servers below contract 0.18.0, which the client treats as `false` — the
       * report dialog and crash-report auto-open stay hidden without it.
       */
      issueReporting: z.boolean().optional(),
      /**
       * Whether this server can author automation rules — it needs the catalogue tools, without
       * which a model can describe a rule but never compose a valid candidate. Absent on servers
       * that lack them, which the client treats as `false`: the free-text box on New rule stays
       * disabled and says so, rather than accepting a description nothing can act on.
       */
      automationRuleAuthoring: z.boolean().optional(),
    }),
    z.object({
      status: z.literal('spendingLimitReached').openapi({example: 'spendingLimitReached'}),
    }),
  ])
  .openapi('AssistantAvailabilityResponse');

export type AssistantAvailabilityResponse = z.infer<typeof assistantAvailabilityResponseSchema>;
